<p>menu-show works!</p>
